import React, { useCallback, useEffect, useMemo, useState, useRef } from 'react';
import {
    ReactFlow,
    Controls,
    addEdge,
    applyEdgeChanges,
    applyNodeChanges,
    Handle,
    Position,
    ReactFlowProvider,
    useReactFlow,
    Background,
    useNodesState,
    useEdgesState,

} from '@xyflow/react';

import '@xyflow/react/dist/style.css';
import useUndoable from "use-undoable";
import debounce from 'lodash/debounce';
import TriggerComp from './comps/trigger/main';

import "./main.css"

import { Button, Radio, Flex, Dropdown, Space, Typography, Breadcrumb, Drawer, FloatButton, Input, message, Modal, Tooltip, Tag, Popover, Popconfirm, Spin } from 'antd';
import { v4 as uuidv4 } from 'uuid';
import { AlignLeftOutlined, CalendarOutlined, CheckOutlined, CommentOutlined, DollarOutlined, EditOutlined, FieldTimeOutlined, FileExcelOutlined, FileTextOutlined, FireOutlined, FontColorsOutlined, ForkOutlined, HomeOutlined, InstagramFilled, MailOutlined, MergeOutlined, MoreOutlined, NumberOutlined, OrderedListOutlined, PhoneOutlined, PictureOutlined, PlusOutlined, RedoOutlined, SendOutlined, ThunderboltOutlined, ThunderboltTwoTone, UndoOutlined, UnorderedListOutlined, UserAddOutlined } from '@ant-design/icons'
import WelcomeComp from './comps/welcome_message/main';
import MessageReply from './comps/message_reply/main';
import FollowersOnly from './comps/followers_only/main';
import { CustomEdge } from './comps/handler/main'

import { Link, useSearchParams } from "react-router-dom";

import { fireDB } from "../../funcs/firebase";
import { GiChoice } from "react-icons/gi";
// import { ref, set,  doc, setDoc } from "firebase/database";
import { FaStarHalfStroke } from "react-icons/fa6";
import { doc, setDoc, getDoc } from "firebase/firestore";
import QuestionNode from './comps/question_node/main';
import callAPI from '../../comps/fetch/main';


import DeleteNode from "./comps/delete_node/main";
import GoogleButton from '../../comps/googleOauth/google_oauth';

const saveDraftAutomation = async (userId, automationId, automationData, setSaving) => {

    const cleanAutomationData = (automationData) => {
        if (automationData.edges && Array.isArray(automationData.edges)) {
            automationData.edges = automationData.edges.map(edge => {
                if (edge.data && typeof edge.data === "object") {
                    const cleanedData = { ...edge.data };
                    delete cleanedData.onDelete; // Remove the onDelete function
                    return { ...edge, data: cleanedData };
                }
                return edge;
            });
        }
        const normalizedData = Object.fromEntries(
            Object.entries(automationData).map(([key, value]) => [key, value === undefined ? "undefiend" : value])
        );
        return normalizedData;
    };

    let automationDataCpy = cleanAutomationData({ ...automationData })
    try {


        const docRef = doc(fireDB, 'automations', userId, 'draft_automations', automationId);


        await setDoc(docRef, automationDataCpy);
        setSaving("Draft Saved...", automationDataCpy)

    } catch (error) {
        setSaving("Draft save failed...")
        console.error("Error saving draft automation:", automationDataCpy, error);

    }

};


function Notes({ id, data }) {

    const { updateNodeData } = useReactFlow();
    const [notes, setNotes] = useState(data?.notes || "")

    useEffect(() => {
        updateNodeData(id, { ...data, notes: notes })
    }, [])


    return (
        <div className="flow-comp" style={{ backgroundColor: "yellow" }}>

            <DeleteNode updateNodeData={updateNodeData} id={id} data={data} />
            <Input.TextArea placeholder='Add your notes here' value={notes} onChange={(e) => setNotes(e.target.value)} />

        </div>
    )
}

const nodeTypes = {
    triggerComp: TriggerComp,
    welcomeComp: WelcomeComp,
    messageReply: MessageReply,
    notes: Notes,
    followersOnly: FollowersOnly,
    questionNode: QuestionNode
}

const edgeTypes = { 'custom-edge': CustomEdge }




function FlowComp() {

    const reactFlowWrapper = useRef(null);

    const [messageApi, contextHolder] = message.useMessage();

    // const { Text, Link } = Typography;
    const [open, setOpen] = useState(false)
    const [searchParams] = useSearchParams();
    const automation_id = searchParams.get("id");

    const [discardChanges, setDiscardChanges] = useState(false)


    const initialNodes = [
        {
            id: 'node-1',
            type: 'triggerComp',
            position: { x: 40, y: 40 },
            data: {
                auto_reply: {
                    dm_reply: {},
                    story_reply: {},
                    comment_reply: {},
                    welcome_message: {
                        "title": "",
                        "description": "",
                        "button": ""
                    }
                }
            },
        },

        {
            id: 'node-3',
            type: 'messageReply',
            position: { x: 100, y: 60 },
            data: {

                toogleDrawer: false,


                messages: [
                    {
                        "id": 1,
                        "type": "text",
                    }
                ]
            },
        },
    ];

    const initialEdges = [];

    const [maxvalue, setMaxValue] = useState({ maxX: 100, maxY: 100 })

    const [savingtoLive, setSavingToLive] = useState(false)
    const [savedToProd, setSavedToProd] = useState({})

    const [savetoprodfb, setSavetoProdFB] = useState(false)

    const [ogData, setOGData] = useState(undefined)
    const [loadOGDATA, setLoadOGDATA] = useState(false)

    const [showEditNameModal, setShowEditNameModel] = useState(false)

    const [editInpuName, setEditInputName] = useState()

    const [newSheetName, setNewSheetName] = useState()

    const [newSheetCreated, setNewSheetCreated] = useState({})
    const [newSheetLoading, setNewSheetLoading] = useState(false)


    const deleteEdge = (id) => {
        // alert(id)
        crSetState((prevState) => ({
            ...prevState,
            edges: prevState.edges.filter((edge) => edge.id !== id)
        }));
    };

    const saveChangeToLive = () => {

        let apiURL = `/flow_editor?flow_id=${automation_id}`
        callAPI({ url: apiURL, method: "POST", body: crState, loadingState: setSavingToLive, dataState: setSavedToProd })

        crSetState({ ...crState, live: true, unsaved_changes: false, published_on: `${new Date()}` })
    }

    useEffect(() => {

        if (ogData != undefined) {
            console.log("-=-=-OG DATA-=-", ogData)
            if (ogData?.data?.raw_flow_data != undefined) {
                setOGData(ogData?.data?.raw_flow_data)
            }

            return
        }

        let url = `/flow_editor?flow_id=${automation_id}`
        callAPI({ url: url, method: "GET", loadingState: setLoadOGDATA, dataState: setOGData })

    }, [ogData])

    function createNewSheet() {

        let url = `/google-new-sheet`
        callAPI({
            url: url, method: "POST", body: { "title": newSheetName }, loadingState: setNewSheetLoading, dataState: (data) => {
                setNewSheetCreated(data)
                setNewSheetLoading(false)

                if (data?.code == 200) {
                    messageApi.success("Sheet Synced.")
                    setShowGsheetPopup(false)
                    crSetState({ ...crState, gsheet_id: data?.data?.id, gsheetName: data?.data?.name })
                }

            }
        })

    }


    const [gSheetList, setGsheetList] = useState({})
    const [gSheetListLoading, setGsheetListLoading] = useState(false)
    const [showGsheetPopup, setShowGsheetPopup] = useState(false)

    useEffect(() => {
        let url = `/google-files`
        callAPI({
            url: url, method: "POST", body: {}, loadingState: setGsheetListLoading, dataState: (data) => {
                setGsheetList(data)
                setGsheetListLoading(false)
            }
        })

    }, [showGsheetPopup])



    const [crState, crSetState, { undo, canUndo, redo, canRedo }] = useUndoable({
        nodes: initialNodes.map((node) => ({
            ...node,
            data: { ...node.data, }
        })),
        edges: initialEdges.map((edge) => ({
            ...edge,
            data: { ...edge.data, onDelete: deleteEdge }
        })),
    });

    useEffect(() => {
        if (!savingtoLive) {
            return
        }
        setSavingToLive(false)
        setOpen(false)
        message.success("Changes Published.")
    }, [savingtoLive])

    useEffect(() => {

        if (!discardChanges || ogData == undefined) {
            return
        }

        setDiscardChanges(false)
        let data = {
            ...ogData, nodes: ogData?.nodes?.map((node) => ({
                ...node,
                data: { ...node.data, }
            })) || [],
            edges: ogData?.edges?.map((node) => ({
                ...node,
                data: { ...node.data, onDelete: deleteEdge }
            })) || []
        }
        // if(data?.nodes == []){
        //     return
        // }
        crSetState(data)

    }, [discardChanges])


    const [fbloaded, setFBLoaded] = useState(false)
    useEffect(() => {

    }, [fbloaded])

    const [userDetail, setUserDetail] = useState(JSON.parse(localStorage.getItem("userData")))


    useEffect(() => {

        const fetchData = async () => {
            const urlParams = new URLSearchParams(window.location.search);
            const automationId = urlParams.get("id");
            const templateId = urlParams.get("template_id");
            localStorage.setItem("current_automation_id", automationId)
            let user_detail = JSON.parse(localStorage.getItem("userData"))
            setUserDetail(user_detail)
            const userId = user_detail.user_id;

            if (!automationId || !userId) {
                setFBLoaded(true);
                return;
            }

            try {
                const docRef = doc(fireDB, "automations", userId, "draft_automations", automationId);
                const docSnap = await getDoc(docRef);

                if (docSnap.exists()) {
                    // Load existing automation from Firebase
                    let fetched_data = docSnap.data()
                    let data = {
                        ...fetched_data, nodes: fetched_data.nodes.map((node) => ({
                            ...node,
                            data: { ...node.data, }
                        })),
                        edges: fetched_data.edges.map((node) => ({
                            ...node,
                            data: { ...node.data, onDelete: deleteEdge }
                        }))
                    }
                    crSetState(data);
                    messageApi.success("Saved data loaded.")
                } else {
                    // No existing automation found
                    if (templateId) {
                        // Load template from templates.json
                        try {
                            const templatesModule = await import('../automationList/templates.json');
                            const templates = templatesModule.default || templatesModule;
                            const template = templates.templates.find(t => t.id === templateId);

                            if (template) {
                                // Prepare template data for Firebase (without functions)
                                const templateDataForFirebase = {
                                    name: template.name,
                                    description: template.description,
                                    nodes: template.nodes.map((node) => ({
                                        ...node,
                                        data: { ...node.data }
                                    })),
                                    edges: template.edges.map((edge) => ({
                                        ...edge,
                                        type: 'custom-edge',
                                        markerEnd: { type: 'arrowclosed' },
                                        data: {}
                                    }))
                                };

                                // Save template to Firebase (without functions)
                                await setDoc(docRef, templateDataForFirebase);

                                // Prepare template data for state (with functions)
                                const templateDataForState = {
                                    name: template.name,
                                    description: template.description,
                                    nodes: template.nodes.map((node) => ({
                                        ...node,
                                        data: { ...node.data }
                                    })),
                                    edges: template.edges.map((edge) => ({
                                        ...edge,
                                        type: 'custom-edge',
                                        markerEnd: { type: 'arrowclosed' },
                                        data: { onDelete: deleteEdge }
                                    }))
                                };

                                crSetState(templateDataForState);
                                messageApi.success(`Template "${template.name}" loaded successfully!`);
                            } else {
                                messageApi.warning("Template not found. Starting with default.");
                                console.log("Template not found:", templateId);
                            }
                        } catch (error) {
                            console.error("Error loading template:", error);
                            messageApi.error("Failed to load template.");
                        }
                    } else {
                        console.log("No automation found and no template specified!");
                    }
                }
                setFBLoaded(true)
            } catch (error) {
                console.error("Error fetching automation data:", error);
                messageApi.error("Unable to load your data.")
                setFBLoaded(true)
            }
        };

        if (fbloaded == false) {
            messageApi.loading("Please Wait, Loading your data.")

            fetchData();
        }

        else {
            return
        }
    }, [])



    const [visualNodes, setVisualNodes] = useState(crState.nodes)


    const [isDragging, setIsDragging] = useState(false);


    useEffect(() => {
        setVisualNodes(
            crState?.nodes?.map((node) => ({
                ...node,
                data: { ...node.data, } //onDelete: onDeleteNode }
            })) || []
        );
    }, [crState.nodes]);


    const onNodesChange = useCallback(
        (changes) => {

            // console.log("Node changes happened-=-=-=-=", changes,visualNodes)

            let newVisualNodes = applyNodeChanges(changes, visualNodes);
            // console.log("new visuals change nodes", newVisualNodes)
            newVisualNodes = newVisualNodes.filter(node => !node.data?.nodeDeleted);

            setVisualNodes(newVisualNodes);


            if (isDragging) {
                debouncedCrSetState((prevState) => ({ ...prevState, nodes: newVisualNodes }));
            }
            else {
                crSetState({ ...crState, nodes: newVisualNodes })
            }
        },
        [visualNodes, crState, isDragging]
    );


    const onEdgesChange = useCallback(

        (changes) =>
            [crState, visualNodes],
    );

    const debouncedCrSetState = useMemo(
        () => debounce(crSetState, 200),
        [crSetState]
    );

    const onNodeDragStart = () => {
        setIsDragging(true);
    };

    const onNodeDragStop = (event, node) => {


        // crSetState(prev => ({ ...prev, nodes: visualNodesRef.current }));
        setVisualNodes((prevNodes) =>
            prevNodes.map((n) => (n.id === node.id ? { ...n, position: node.position } : n))
        );

        setIsDragging(false);
        debouncedCrSetState.flush();

        crSetState((prev) => ({
            ...prev,
            nodes: prev.nodes.map((n) => (n.id === node.id ? { ...n, position: node.position } : n))
        }));



    };

    const onConnect = useCallback(
        (connection) => {

            console.log("Connection-==-", connection?.id)

            crSetState((prevState) => ({
                ...prevState, edges: addEdge({
                    ...connection,

                    type: 'custom-edge',
                    markerEnd: {
                        type: 'arrowclosed',
                    },
                    data: { onDelete: deleteEdge },
                }, prevState.edges)
            }));
        },
        [crState],
    );

    const [saving, setSaving] = useState("")
    useEffect(() => {
        if (fbloaded == true) {
            setSaving("Draft Saving...")
            let user_detail = JSON.parse(localStorage.getItem("userData"))
            saveDraftAutomation(user_detail.user_id, automation_id, { ...crState }, setSaving);
            // console.log("Saved draft automations...")
        }

    }, [crState])


    const addNewNode = (nodeType, questionType = "", custom_position = {}) => {
        let x = 80
        let y = 80
        console.log("-=-=-=-=-=-=-=-=-custom position-=-=-=-", custom_position)
        messageApi.info("Added.")
        if (custom_position?.x != undefined && custom_position?.y != undefined) {
            x = custom_position.x
            y = custom_position.y
        }
        else if (crState?.nodes != undefined) {
            x = crState.nodes.length > 0 ? Math.max(...crState.nodes.map(node => node.position.x)) + 160 : 80;
            y = crState.nodes.length > 0 ? Math.max(...crState.nodes.map(node => node.position.y)) : 60;
        }
        else {

        }

        let temp_node = {
            id: `node-${crState.nodes.length + 1}-${Date.now()}`,
            type: nodeType,
            position: { x: x, y: y },
            data: {}
        }
        if (nodeType == "followersOnly") {
            temp_node["data"] = {
                "followers_only": true,
                "message_reply": "true",
                "message": {
                    "title": "Follow for exculusive content",
                    "description": "Looks like you haven't followed me, follow for exclusive content.",
                    "button": "I started following you."
                }
            }
        }
        if (nodeType == "messageReply") {
            temp_node["data"] = {

                "messages": []
            }
        }
        if (nodeType == "questionNode") {
            let addType = questionType;
            let helper_text = {
                "name": {
                    "text": "Before we continue please share your full name.",
                    "wrong_input": "oops, it doesn't look like proper name here an example Vin diesal"
                },
                "phone": {
                    "text": "Please share your whatsapp phone number.",
                    "wrong_input": "oops, it doesn't look like proper phone number here an example +919876543210"
                },
                "email": {
                    "text": "Please share your email id, for sharing confirmation details.",
                    "wrong_input": "oops, it doesn't look like proper email here an example me@mail.com"
                },
                "address": {
                    "text": "Please share your address, with street details and pincode(postal) code.",
                    "wrong_input": "oops, it doesn't look like proper address, here is an example : No 34/1, street name, city name, region or state name, country and pincode or postal code "
                },
                "bool": {
                    "text": "is our service statisifed? Customise this question",
                    "wrong_input": "Please choose from the given option",
                    "choice": ["Yes", "No"]
                },
                "number": {
                    "text": "What's ur age or size of the shoe",
                    "wrong_input": "oops, it doesn't look like proper number, here is an example : 10",
                },
                "date": {
                    "text": "What's ur date of birth",
                    "wrong_input": "oops, it doesn't look like proper date,here is the format, May 16 1999.",
                },
                "rating": {
                    "text": "Please share rating for the serivce",
                    "wrong_input": "oops, it doesn't look like proper rating, Please rate on a scale of 1(poor) to 5(very good)",
                    "choice": ["⭐⭐⭐⭐⭐", "⭐⭐⭐⭐", "⭐⭐⭐", "⭐⭐", "⭐"]
                }

            }
            let question_data = {
                skip_option: {
                    enable: false,
                    skip_text: "Skip"
                },
                retry_attempt: {
                    count: 3,
                },
                wrong_input: {
                    message: helper_text?.[addType]?.wrong_input,
                },
                smartReplies: helper_text?.[addType]?.choice || [],
                custom_variable_name: ""
            }
            let new_message = { id: uuidv4(), "question_type": questionType, ...question_data, question: helper_text?.[addType]?.text, }
            temp_node["data"] = {


                "messages": [
                    {
                        ...new_message

                    }
                ]
            }
        }

        crSetState({
            ...crState,
            nodes: [...crState.nodes, temp_node]
        })
        setVisualNodes([...crState.nodes, temp_node])
    }


    const [showBugmodal, setShowBugModal] = useState(false)
    const [feedbackData, setFeedbackData] = useState({})


    const [popup, setPopup] = useState({})

    // const { screenToFlowPosition } = useReactFlow();



    const onConnectEnd = (event, connectionState) => {
        // connectionState comes from React Flow's internal logic
        if (!connectionState?.isValid) {
            // console.warn("Invalid connection attempt", connectionState);
            setPopup({
                visible: true,
                x: event.clientX,
                y: event.clientY,
            });
        }
    }


    function ShowNodeTypes({ marginTop, custom_position }) {
        custom_position = custom_position?.x != undefined ? custom_position : {}

        return (

            <div className='comps-list hide-scroll-bar' style={{ marginTop: marginTop || "600px" }}>

                <div>
                    <h4 style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "10px" }}><InstagramFilled style={{ color: "#ff6e97", fontSize: "20px", opacity: "1" }} /> Instagram</h4>
                    <div className='row-wrap'>
                        {/* <div onClick={() => addNewNode("welcomeComp")}> <SendOutlined style={{fontSize:"18px"}}/>Welcome Message</div> */}
                        <div onClick={() => addNewNode("messageReply", "", custom_position = custom_position)}> <SendOutlined style={{ fontSize: "18px" }} />DM Reply</div>
                        <div onClick={() => addNewNode("followersOnly", "", custom_position = custom_position)}> <UserAddOutlined style={{ fontSize: "18px" }} />Followers only</div>
                        {/* 
                    <Tooltip title="Comming Soon">
                    <div> <DollarOutlined style={{ fontSize: "18px" }} />Payment</div>
                    </Tooltip> */}
                    </div>
                </div>
                <div>
                    <h4 style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "10px" }}><CommentOutlined style={{ color: "#ff6e97", fontSize: "20px", opacity: "1" }} /> Question</h4>
                    <div className='row-wrap'>

                        <div onClick={() => addNewNode("questionNode", "name", custom_position = custom_position)}> <FontColorsOutlined style={{ fontSize: "18px" }} />Name</div>
                        <div onClick={() => addNewNode("questionNode", "email", custom_position = custom_position)}> <MailOutlined style={{ fontSize: "18px" }} />Email</div>
                        <div onClick={() => addNewNode("questionNode", "phone", custom_position = custom_position)}> <PhoneOutlined style={{ fontSize: "18px" }} />Phone</div>
                        <div onClick={() => addNewNode("questionNode", "text", custom_position = custom_position)}> <AlignLeftOutlined style={{ fontSize: "18px" }} />Text</div>
                        <div onClick={() => addNewNode("questionNode", "address", custom_position = custom_position)}> <HomeOutlined style={{ fontSize: "18px" }} />Address</div>
                        {/* <div onClick={() => addNewNode("questionNode", "choice")}> <PhoneOutlined style={{ fontSize: "18px" }} />Choice</div> */}
                        <div onClick={() => addNewNode("questionNode", "bool", custom_position = custom_position)}> <GiChoice style={{ fontSize: "18px" }} />Yes/No</div>

                        <div onClick={() => addNewNode("questionNode", "number", custom_position = custom_position)}> <NumberOutlined style={{ fontSize: "18px" }} />Number</div>
                        <div onClick={() => addNewNode("questionNode", "date", custom_position = custom_position)}> <CalendarOutlined style={{ fontSize: "18px" }} />Date</div>
                        {/* <div onClick={() => addNewNode("questionNode","image")}> <PictureOutlined style={{ fontSize: "18px" }} />Image</div> */}
                        {/* <div onClick={() => addNewNode("questionNode","nps")}> <PictureOutlined style={{ fontSize: "18px" }} />NPS</div> */}
                        <div onClick={() => addNewNode("questionNode", "rating", custom_position = custom_position)}> <FaStarHalfStroke style={{ fontSize: "18px" }} />Star Rating</div>
                    </div>
                </div>
                <div>
                    <h4 style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "10px" }}><ForkOutlined style={{ color: "#ff6000", fontSize: "20px", opacity: "1" }} /> Extras</h4>
                    <div className='row-wrap'>
                        <div onClick={() => addNewNode("notes")}><FileTextOutlined style={{ fontSize: "18px" }} />Notes</div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="node-editor hide-scroll-bar" ref={reactFlowWrapper} >

            {contextHolder}

            <div className='node-editor-header'>
                <div style={{ display: 'flex', flexDirection: 'row', gap: '20px' }}>
                    <Breadcrumb
                        routes={[
                            {

                                breadcrumbName: (
                                    <Link to="/?tab=3">
                                        Automations
                                    </Link>),
                            },
                            {
                                breadcrumbName: (
                                    <span>
                                        {crState?.name || "Un-named"}
                                        <EditOutlined
                                            style={{ marginLeft: 8, cursor: 'pointer' }}
                                            onClick={() => { setShowEditNameModel(true) }}
                                        />
                                    </span>
                                ),
                            }
                        ]}

                    />
                    {/* <Tag color='purple'>Beta</Tag> */}
                </div>

                <div style={{ display: 'flex', flexDirection: 'row', gap: '20px', alignItems: 'center', marginRight: "40px", padding: "10px", borderRadius: "10px", backgroundColor: "rgba(255, 255, 255, 1)" }}>

                    {userDetail?.user_id == "6cfc1fe8-a565-4e23-ab38-f6f4ea494878" && <Tooltip title={crState?.gsheet_id ? `${crState?.gsheetName} Google Sheet connected. All responses will be saved automatically.` : "Automatically sync lead data to Google Sheets."}>
                        <Button onClick={() => crState?.gsheet_id ? {} : setShowGsheetPopup(true)} icon={<FileExcelOutlined />} style={{ backgroundColor: "hsla(120, 100%, 19%, 1.00)", color: "white" }} variant="solid">{crState?.gsheet_id ? (crState?.gsheetName?.length > 15
                            ? crState?.gsheetName?.slice(0, 15) + "..."
                            : crState?.gsheetName) : "Google Sheets"}</Button>
                    </Tooltip>}

                    <Tooltip title="Your data is safe, just click this button, try refreshing Or contact us.">
                        <Popconfirm title="Are you sure want to restore your data?" okText="Yes, Restore My data" cancelText="Cancel" onConfirm={() => setDiscardChanges(true)}>
                            <Button color="danger" variant="solid">Data Missing?</Button>
                        </Popconfirm>

                    </Tooltip>
                    <div>
                        <p style={{ opacity: ".4", fontSize: '12px' }}>{saving}</p>
                    </div>

                    <Button onClick={() => { setDiscardChanges(true) }}>Discard changes</Button>
                    <Button type="primary" onClick={() => { setOpen(true) }} size="large" style={{ width: '160px' }}>Set Live</Button>

                    {popup.visible && (
                        <div
                            style={{
                                position: 'fixed',
                                left: popup.x,
                                top: popup.y,
                                background: '#fff',
                                border: '1px solid #ccc',
                                padding: '8px 16px',
                                borderRadius: '6px',
                                zIndex: 9999,
                                width: '350px',
                                maxHeight: '400px',
                                overflowY: 'auto',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
                            }}

                        >
                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                                <h3>What you want to do?</h3>
                                <Button onClick={() => setPopup({ ...popup, visible: false })}>Close</Button>

                            </div>
                            <div className='row-wrap' style={{ display: "flex", flexDirection: "column" }} >

                                <div onClick={() => addNewNode("messageReply", "",)}> <SendOutlined style={{ fontSize: "18px" }} />DM Reply (Text, Image, Audio)</div>
                                <div onClick={() => addNewNode("followersOnly", "",)}> <UserAddOutlined style={{ fontSize: "18px" }} />Followers only</div>


                                <div onClick={() => addNewNode("questionNode", "name",)}> <FontColorsOutlined style={{ fontSize: "18px" }} />Name</div>
                                <div onClick={() => addNewNode("questionNode", "email",)}> <MailOutlined style={{ fontSize: "18px" }} />Email</div>
                                <div onClick={() => addNewNode("questionNode", "phone",)}> <PhoneOutlined style={{ fontSize: "18px" }} />Phone</div>
                                <div onClick={() => addNewNode("questionNode", "text",)}> <AlignLeftOutlined style={{ fontSize: "18px" }} />Text</div>
                                <div onClick={() => addNewNode("questionNode", "address",)}> <HomeOutlined style={{ fontSize: "18px" }} />Address</div>
                                {/* <div onClick={() => addNewNode("questionNode", "choice")}> <PhoneOutlined style={{ fontSize: "18px" }} />Choice</div> */}
                                <div onClick={() => addNewNode("questionNode", "bool",)}> <GiChoice style={{ fontSize: "18px" }} />Yes/No</div>

                                <div onClick={() => addNewNode("questionNode", "number",)}> <NumberOutlined style={{ fontSize: "18px" }} />Number</div>
                                <div onClick={() => addNewNode("questionNode", "date",)}> <CalendarOutlined style={{ fontSize: "18px" }} />Date</div>
                                {/* <div onClick={() => addNewNode("questionNode","image")}> <PictureOutlined style={{ fontSize: "18px" }} />Image</div> */}
                                {/* <div onClick={() => addNewNode("questionNode","nps")}> <PictureOutlined style={{ fontSize: "18px" }} />NPS</div> */}
                                <div onClick={() => addNewNode("questionNode", "rating",)}> <FaStarHalfStroke style={{ fontSize: "18px" }} />Star Rating</div>
                            </div>
                            {/* <ShowNodeTypes marigntop={"-100px"} custom_position={{x: popup.x , y: popup.y}}/> */}
                        </div>
                    )}

                </div>
                <FloatButton.Group
                    className='addIcon'
                    trigger='click'
                    type="primary"
                    placement="left"
                    style={{
                        insetInlineEnd: 0,
                        position: "absolute"
                    }}
                    icon={<PlusOutlined />}
                >

                    <ShowNodeTypes marigntop={"600px"} />
                </FloatButton.Group>
            </div>

            <ReactFlowProvider >
                <ReactFlow
                    nodes={visualNodes}
                    edges={crState.edges}
                    onNodeDragStart={onNodeDragStart}
                    onNodeDragStop={onNodeDragStop}
                    onNodesChange={onNodesChange}
                    onEdgesChange={onEdgesChange}
                    onConnect={onConnect}
                    onConnectEnd={(event, connectionState) => onConnectEnd(event, connectionState)}
                    snapToGrid={true}
                    snapGrid={[20, 20]}
                    proOptions={{ hideAttribution: true }}
                    nodeTypes={nodeTypes}
                    edgeTypes={edgeTypes}
                    fitView
                    className='hide-scroll-bar'

                >
                    <Controls />
                </ReactFlow>
            </ReactFlowProvider>

            <Modal
                title="Publish your changes!"
                open={open}
                width={500}
                height={600}
                okText="Yes, Publish my changes."
                onOk={() => {
                    saveChangeToLive()
                    setOpen(false)
                }}
                onCancel={() => { setOpen(false) }}
            >

                Are you sure you want to publish these changes to the live version of the automation?

            </Modal>

            <Modal
                title="Edit Automation Name"
                open={showEditNameModal}
                width={500}
                height={600}
                okText="Save Changes"
                onOk={() => {
                    if (editInpuName) {
                        crSetState({ ...crState, name: editInpuName })
                    }
                    setShowEditNameModel(false)
                }}
                onCancel={() => { setShowEditNameModel(false) }}
            >

                <h3>Automation Name</h3>
                <Input placeholder='Ex. Hair products flow' value={editInpuName || crState.name} onChange={(e) => setEditInputName(e.target.value)} />

            </Modal>

            <Modal
                title="Feedback on Flow editor"
                open={showBugmodal}
                width={500}
                height={600}
                okText="Share Feedback"
                onOk={() => {
                    let user_detail = JSON.parse(localStorage.getItem("userData"))
                    let igid = localStorage.getItem("ig_id")
                    const BOT_TOKEN = "7109212238:AAEsaFubA66rs0Ib6rgn5K2amKO9rnOkUv0";
                    const CHAT_ID = '776956029';
                    const url = `https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`;
                    let tele_message = `[FLOW EDITOR FEEDBACK] - user ${user_detail.emailid}  - ${feedbackData?.useful} ${feedbackData?.feedback} `
                    let data = {
                        chat_id: CHAT_ID,
                        text: tele_message
                    };


                    fetch(url, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(data)
                    })
                        .then(response => response.json())
                        .then(data => {
                            console.log('Message sent successfully:', data);
                        })
                        .catch(error => {
                            console.error('Error sending message:', error);
                        });
                    setShowBugModal(false)
                }
                }
                onCancel={() => {

                    let user_detail = JSON.parse(localStorage.getItem("userData"))
                    let igid = localStorage.getItem("ig_id")
                    const BOT_TOKEN = "7109212238:AAEsaFubA66rs0Ib6rgn5K2amKO9rnOkUv0";
                    const CHAT_ID = '776956029';
                    const url = `https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`;
                    let tele_message = `[FLOW EDITOR FEEDBACK] - user ${user_detail.emailid}  - ${feedbackData?.useful} ${feedbackData?.feedback} `
                    let data = {
                        chat_id: CHAT_ID,
                        text: tele_message
                    };

                    if (!feedbackData?.feedback && !feedbackData?.useful) {

                        return
                    }
                    fetch(url, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(data)
                    })
                        .then(response => response.json())
                        .then(data => {
                            console.log('Message sent successfully:', data);
                        })
                        .catch(error => {
                            console.error('Error sending message:', error);
                        });
                    setShowBugModal(false)

                }} >

                <h4>Do you think this flow editor will be useful for you?</h4>

                <Radio.Group
                    onChange={(e) => setFeedbackData({ ...feedbackData, useful: e.target.value })}
                    options={[
                        { value: 4, label: "Very much useful" },
                        { value: 3, label: "Somewhat" },
                        { value: 2, label: "ok" },
                        { value: 1, label: "Not useful" },
                    ]}
                />
                <h4>Share your thoughts, questions, suggestions, or anything!</h4>
                <Input.TextArea
                    onChange={(e) => setFeedbackData({ ...feedbackData, feedback: e.target.value })}
                    placeholder='Share your feedback' minLength={6} />

            </Modal>

            <Modal
                title="Connect Google Sheets"
                open={showGsheetPopup}
                width={500}
                height={600}
                onCancel={() => { setShowGsheetPopup(false) }}
                footer={[]}
            >
                {gSheetList?.code != 200 && (
                    <div style={{ marginTop: "20px", flexDirection: "column", marginBottom: 20, display: "flex", justifyContent: "center", alignContent: "center", justifyItems: "center", alignItems: "center" }}>
                        <GoogleButton callback={() => {
                            // alert("ok")
                            setShowGsheetPopup(false)

                            setTimeout(() => {
                                setShowGsheetPopup(true)
                            }, 10)


                        }} />
                        <p style={{ color: "#555" }}>
                            After connecting, all responses will sync automatically to your selected sheet
                        </p>
                    </div>
                )}



                {gSheetListLoading ? <Spin /> : null}

                {(gSheetList?.code == 200 && !crState?.gsheet_id) && <div style={{ display: "flex", gap: 12, marginTop: 16 }}>

                    <Input
                        placeholder="Enter new sheet name"
                        value={newSheetName}
                        onChange={(e) => setNewSheetName(e.target.value)}
                        style={{
                            flex: 1,
                            padding: "10px 12px",
                            border: "1px solid #ddd",
                            borderRadius: 8,
                        }}
                    />
                    <Button
                        onClick={() => { newSheetName?.length >= 4 ? createNewSheet() : messageApi.error("Minimum filename should be 4 char.") }}
                        loading={newSheetLoading}
                        icon={<FileExcelOutlined />}
                        style={{ backgroundColor: "hsla(120, 100%, 19%, 1.00)", color: "white" }} variant="solid"

                        size='large'
                    >
                        Create & Connect Sheet
                    </Button>
                </div>}

                {/* <div style={{ display: "flex", flexWrap: "wrap", gap: 16, marginTop: 16 }}>
                {gSheetList?.data?.files?.map((file) => {
                return (
                    <div
                    key={file.id}
                    style={{
                        padding: 12,
                        border: "1px solid #eee",
                        borderRadius: 8,
                        cursor: "pointer",
                    }}
                    >
                    {file.name}
                    </div>
                )
                })}
            </div> */}

            </Modal>

        </div>
    );
}

export default FlowComp;
